(function () {
  const slider = document.querySelector('#product-slider');
  if(!slider) return;

   const productSlider = new Splide ('#product-slider', {
        drag: true,
        fixedHeight: 500,
        arrows: true,
        pagination: false,
        speed: 800,
        cursor: 'grab',
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        perMove: 1,
        perPage: 1,
        flickPower: 300,
        flickMaxPages: 1,
        gap: '1rem',
        breakpoints: {
           610: {
        	  gap: '.4rem',
              pagination: 'true',
            }
          }
      });

      const productThumbnailSlider = new Splide ('#thumbnails-slider',  { 
        fixedWidth : 100,
        fixedHeight: 100,
        gap        : 8,
        rewind     : true,
        pagination : false,
        isNavigation: true,
        arrows: false,
        focus: 'center',
        rewind: false,
      });

      productSlider.sync( productThumbnailSlider );
      
      productSlider.mount();
      productThumbnailSlider.mount()
})()
     